import * as React from "react";
import * as Dtos from "../dtos/Tmd.dtos";

export interface IAuthenticatedUserContext {
    user?: Dtos.User;
    userSummary?: Dtos.UserSummary;
    permissions: Dtos.PersonnelTmdPermissions[];
}

const AuthenticatedUserContext = React.createContext<IAuthenticatedUserContext | undefined>(undefined);

export const useAuthenticatedUser = (): IAuthenticatedUserContext => {
    const context = React.useContext(AuthenticatedUserContext);

    if (!context) {
        throw new Error("useAuthenticatedUser must be used within AuthenticatedUserProvider");
    }

    return context;
};

export default AuthenticatedUserContext;
